import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useRouteMatch } from "react-router-dom";
import DetailsByBlogId from "./DataNewsById";

const DetailsBlog = (props) => {
  const webmasterTitle = useRouteMatch().params.webmasterTitle;
  const { t } = useTranslation();
  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>
                  {t(webmasterTitle)} {t("Details")}
                </h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/dataNews/${webmasterTitle}/topics`}>
                      {t(webmasterTitle)}-list
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t(webmasterTitle)}-{t("Details")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <DetailsByBlogId t={t} myid={props.match.params} />
    </div>
  );
};

export default DetailsBlog;
